import { isFilledSignPopup, isRequestSignatureSignPopup } from 'Popups/helpers';
import PopupConstants from 'Popups/PopupConstants';

export const DEFAULT_STATE = false;

const signExpanded = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case 'ATTACH_TO_MOUSE_SET':
      return action.isPopupAttachedToMouse ? false : state;
    case PopupConstants.ACTIVATE_NEXT_UNFILLED_POPUP:
    case PopupConstants.POPUP_DIRECT_SELECT:
      return (
        isRequestSignatureSignPopup(action.popup)
        && !isFilledSignPopup(action.popup)
        && !action.lastUsedImageUrl
      );
    case 'SIGNATURE_MANAGER_POPUPID_LOAD':
      return action.signExpanded;
    case 'SIGNATURE_SECTION_SHOW':
    case 'ADD_SIGNATURE_SECTION_SHOW':
      return true;
    case 'HIDE_SIGNATURE_SECTION':
    case 'SAVE_SIGNATURE_SUCCESS':
    case 'UPDATE_REQUEST_SIGNATURE_CONTENT':
      return false;
    default:
      return state;
  }
};

export default signExpanded;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/SignatureReducer/signExpanded.jsx